import {
  IbanValidation,
  IsRequiredValidation,
  HasMaxLengthValidation,
  PostcodeValidation,
  BedragValidation,
  HasFileMaxSizeValidation,
  HasSpecificLengthValidation,
  HasMaxFilesUploadValidation,
  DateValidation,
  DecimalValidation,
  IntegerValidation
} from "@generation/form";
import { translate } from "../locales/src/translate";
import { BsnValidation } from "./bsn-validation";
import { DateNotInFutureValidation } from "./date-not-in-future";
import { HasMinimalAmountValidation } from "./HasMinimalAmountValidation";

export const IsRequiredValidationFactory = () =>
  new IsRequiredValidation(false);
export const IsIbanValidationFactory = () =>
  new IbanValidation(false);
export const HasMaxLengthValidationFactory = (maxLength?: number) =>
  new HasMaxLengthValidation(
    maxLength ?? 50,
    undefined,
    true
  );
export const MinimalAmountValidationFactory = (minimalAmount: number, errorText?: string) =>
  new HasMinimalAmountValidation(
    minimalAmount,
    () =>
      errorText ??
      "Het minimumbedrag voor een betalingsregeling is € 10 per maand. Kunt u dit niet missen? Neem dan telefonisch contact met ons op.",
    true
  );
export const IsPostcodeValidationFactory = () =>
  new PostcodeValidation(
    false);
export const IsBedragValidationFactory = () =>
  new BedragValidation(
    false,
    (label?: string) =>
      `U heeft het invulveld '${label}' niet juist ingevuld. voorbeeld: 2500 of 2.500,00 (vervangen door uw inkomen).`
  );

export const HasFileMaxSizeValidationFactory = () =>
  new HasFileMaxSizeValidation(
    5,
    (label?: string) => translate("FileMaxSizeValidationText", { label: label || "" }),
    (fileLabel?: string) => translate("FileMaxSizeValidationTextAlternative", { label: fileLabel || "" })
  );

export const HasMaxFilesUploadValidationFactory = (maxFiles?: number) =>
  new HasMaxFilesUploadValidation(maxFiles ?? 5, (label?: string) =>
    translate("FileMaxNumberOfAttachmentsValidationText", {
      label: label || "",
      maxFiles: (maxFiles ?? 5).toString(),
      bijlagen: (maxFiles ?? 5) === 1 ? translate("bijlage") : translate("bijlagen")
    })
  );

export const DateValidationFactory = (isRequired = true) =>
  new DateValidation(isRequired, (label?: string) =>
    translate("DateValidationFactoryValidationText", { label: label || "" })
  );

export const DateNotInFutureValidationFactory = (isRequired = true) =>
  new DateNotInFutureValidation(isRequired, (label?: string) =>
    translate("DateNotInFutureValidationFactoryText", { label: label || "" })
  );

export const BsnValidationFactory = () =>
  new BsnValidation(false, (label?: string) => translate("BsnValidationFactoryText", { label: label || "" }));

export const IsKlantkaartDecimalValidationFactory = () =>
  new DecimalValidation(false, (label?: string) =>
    translate("BestaatUit10DigitsTekst", { label: label || "" })
  );

export const IsDecimalValidationFactory = () =>
  new DecimalValidation(false, (label?: string) =>
    translate("IsDecimalValidationText", { label: label || "" })
  );

export const HasSpecificLengthValidationFactory = (specificAmount: number) =>
  new HasSpecificLengthValidation(
    specificAmount,
    (label?: string) =>
      `U heeft het invulveld '${label}' niet juist ingevuld. Het veld moet ${specificAmount} cijfers bevatten.`,
    true
  );

export const IsIntegerValidationFactory = () =>
  new IntegerValidation(false, (label?: string) =>
    translate("IntegerValidationText", { label: label || "" })
  );
